import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canViewHorizontalNavMenuLink(_vm.item))?_c(VListItem,_vm._b({class:{'v-item--active v-list-item--active': _vm.isActive}},'v-list-item',_vm.linkProps,false),[_c(VListItemIcon,[_c(VIcon,{attrs:{"size":_vm.item.icon ? 22 : 15}},[_vm._v(" "+_vm._s(_vm.item.icon || _vm.alternateIcon)+" ")])],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(_vm.t(_vm.item.title)))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }